import { useTranslation } from 'react-i18next';
import { Box, Typography, IconButton } from '@mui/material';
import Apple from '@mui/icons-material/Apple';
import Android from '@mui/icons-material/Android';
import { app } from '../constants/constants';

export default function InstallApp() {
    const { t } = useTranslation();

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 2, md: 3 },
                px: { xs: 2, md: 4 },
                backgroundColor: 'rgba(248, 250, 252, 0.6)',
                borderTop: '1px solid rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
            }}
        >
            <Box
                sx={{
                    maxWidth: '650px',
                    margin: 'auto',
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                {/* Texto */}
                <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                    <Typography
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '1rem', md: '1.1rem' },
                            fontWeight: 600,
                            color: '#1a202c',
                            mb: 0.5,
                        }}
                    >
                        {t('BannerApp02')}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '0.8rem', md: '0.9rem' },
                            color: 'text.secondary',
                        }}
                    >
                        {t('BannerApp03')}
                    </Typography>
                </Box>

                {/* Botones de descarga */}
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                    }}
                >
                    <IconButton
                        onClick={() => window.open('https://apps.apple.com/app/icoachbasketball-com/6478594779', '_blank')}
                        sx={{
                            width: 40,
                            height: 40,
                            backgroundColor: '#000000',
                            color: 'white',
                            borderRadius: 2,
                            '&:hover': {
                                backgroundColor: '#333333',
                                transform: 'scale(1.05)',
                            },
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <Apple sx={{ fontSize: '1.2rem' }} />
                    </IconButton>

                    <IconButton
                        onClick={() => window.open(`${app}installandroid`, '_blank')}
                        sx={{
                            width: 40,
                            height: 40,
                            backgroundColor: '#01875f',
                            color: 'white',
                            borderRadius: 2,
                            '&:hover': {
                                backgroundColor: '#00a86b',
                                transform: 'scale(1.05)',
                            },
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <Android sx={{ fontSize: '1.2rem' }} />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    );
};